import Vue from 'vue';
import App from '@/App.vue';
import router from '@/routes/index.js';
import store from '@/store/index';
import { formatDate } from '@/utils/filters';
import vuetify from '@/plugins/vuetify';
import { directives } from './directive';

import CKEditor from '@ckeditor/ckeditor5-vue2';
//import VueMobileDetection from 'vue-mobile-detection';

import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import moment from 'moment';
import BasePopup from '@/components/common/BasePopup.vue';

Vue.component('BasePopup', BasePopup);
Vue.component('VueCustomScrollbar', vueCustomScrollbar);
Vue.filter('formatDate', formatDate);
import Dialog from '@/plugins/dialog';
import { i18n, i18nComponentInstall } from './plugins/locales';
Vue.use(Dialog);

Vue.filter('momentDate', (value, format = 'YYYY-MM', defaultValue) => {
  try {
    if (!value) {
      return defaultValue ?? value;
    }
    return moment(value).format(format);
  } catch (error) {
    console.warn(error);
    return defaultValue ?? value;
  }
});

Object.entries(directives).forEach(([name, action]) => {
  Vue.directive(name, action);
});
Vue.use({ install: i18nComponentInstall });
Vue.use({
  install: function(Vue) {
    Vue.prototype.$ = require('jquery'); // you'll have this.$jQuery anywhere in your vue project
  },
});

Vue.config.productionTip = false;
//Vue.use(VueMobileDetection);
Vue.use(CKEditor);
const vm = new Vue({
  render: h => h(App),
  router,
  vuetify,
  i18n,
  store,
}).$mount('#app');

window.app = vm;
